const focussableElements = 'a:not([disabled]), button:not([disabled]), input:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

const focusNextElement = (fromElement) => {
  if (document.activeElement) {
    const focussable = Array.prototype.filter.call(document.querySelectorAll(focussableElements),
      (element) => element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement);

    const index = focussable.indexOf(document.activeElement);
    setTimeout(() => {
      const nextElement = focussable[index + 1];
      document.activeElement === fromElement && nextElement && nextElement.focus();
    }, 0);
  }
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  focusNextElement,
};
